import { defineComponent, reactive, toRefs } from "vue";
import { onBeforeRouteLeave, useRouter } from "vue-router";
import { store } from "./store/MailAddressChangeStore";
import { Log, Validator, presence, maxLength } from "~/extensions/utils";
import { useLoad } from "../password/composition/Load";
import { MsgBox } from "~/components/MsgBox";
import Loading from 'quasar/src/plugins/loading/Loading.js';
import { AuthorizationCode } from "~/api/data/AuthorizationCode";
import { myPageStore } from "~/store/MyPageStore";
import BreadcrumbList from "~/components/BreadcrumbList.vue";
import { commonStore } from "~/store/CommonStore";
import { PageID } from "~/extensions/utils/DefineTypes";
const log = Log.create("PasswordChangePage");
// エラーメッセージ
const requiredErrorMessage = "入力してください。";
const constraints = {
    authCode: {
        presence: presence(false, requiredErrorMessage),
        length: maxLength(16)
    }
};
export default defineComponent({
    name: "MailAddressChangePage",
    components: {
        BreadcrumbList
    },
    beforeRouteEnter(to, from, next) {
        if (store.mailAddress && (from.name === "mailaddress-change" || !from.name)) {
            next();
            return;
        }
        next({ name: "mailaddress-change" });
    },
    setup() {
        const data = reactive(new AuthorizationCode());
        const { loading } = useLoad();
        const router = useRouter();
        const hasAddress = myPageStore.personal.hasMailAddress;
        // 画面名取得
        const pageName = commonStore.pageName(PageID.mailaddressCheck);
        const valid = reactive(new Validator(data, constraints));
        // 画面から離れた場合、ストアクリアを実施
        onBeforeRouteLeave(() => {
            store.clear();
        });
        const submit = async () => {
            valid.reset();
            if (valid.error || !data.authCode) {
                MsgBox.error("入力に不備があります。<br/>確認してください。");
                return;
            }
            try {
                Loading.show();
                await store.validate(data);
                myPageStore.load();
                await myPageStore.waitForBasic();
                router.push({ name: "mailaddress-change-complete", state: { isUpdate: hasAddress } });
            }
            catch (ex) {
                if (!valid.handle(ex)) {
                    log.error("MailAddressChangePage", ex);
                    MsgBox.error(ex.message);
                }
            }
            finally {
                Loading.hide();
            }
        };
        return {
            ...toRefs(store),
            ...useLoad(),
            loading,
            data,
            valid,
            submit,
            hasAddress,
            pageName,
            PageID
        };
    }
});
